import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import ErrorTemplateBody from './ErrorTemplateBody';
var Unauthorized401Page = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var edsContext = props.edsContext;
  var errorTitle = props.errorTitle || edsContext.formatMessage('component.ErrorPage.401');
  var errorMessage = edsContext.formatMessage('component.ErrorPage.401.message');
  var signInText = edsContext.formatMessage('component.ErrorPage.signInText');
  return /*#__PURE__*/React.createElement(ErrorTemplateBody, _extends({}, props, {
    largeIllustrationName: props.narrow ? '401Narrow.png' : '401.png',
    errorTitle: errorTitle,
    errorMessage: errorMessage,
    text: signInText,
    ref: ref
  }));
});
Unauthorized401Page.displayName = 'Unauthorized401Page';
Unauthorized401Page.propTypes = {
  edsContext: PropTypes.object,
  narrow: PropTypes.bool,
  errorTitle: PropTypes.string
};
export default Unauthorized401Page;